import { useSelector } from 'react-redux'
import getCapabilities, { Capabilities } from '../utils/capabilities'

/**
 * Reads the logged-in user from the auth slice (`state.userLogin.userInfo`)
 * and returns their capability set. One import everywhere UI needs to gate on
 * account type — create buttons, nav tabs, route guards.
 *
 * The backend remains the enforcer; this is for UX (hide vs. dead-end).
 */
const useCapabilities = (): Capabilities => {
	const userInfo = useSelector((state: any) => state.userLogin?.userInfo)
	return getCapabilities(userInfo)
}

export default useCapabilities
